<div class="map-header-controls">
  <ul class="links">
    <li
      #buildingMenuTrigger="matMenuTrigger"
      class="link buildings-option"
      [class.-active]="isBuildingMenuOpen"
      *ngIf="!!authService.permissions.BUILDING_TYPE_UPDATE || !!authService.permissions.BUILDING_LOCATION_UPDATE"
      [matMenuTriggerFor]="buildingMenu"
    >
      <div>
        <app-svg-icon class="app-svg-icon" src="./assets/icons/icoBuilding.svg"></app-svg-icon>
        <div class="red-mark" *ngIf="hasBuildingsWithNoCoordinatesOrType"></div>
      </div>
      <mat-menu #buildingMenu="matMenu" class="buildings-map-mat-menu" panelClass="buildings-map-mat-menu">
        <ng-template matMenuContent>
          <app-buildings-option-new></app-buildings-option-new>
        </ng-template>
      </mat-menu>
    </li>
    <li
      #userprofileMenuTrigger="matMenuTrigger"
      class="link user-profile-submenu"
      [class.-active]="isUserProfileMenuOpen"
      [matMenuTriggerFor]="userprofileMenu"
    >
      <span class="fa fa-user-circle"></span>
      <mat-menu #userprofileMenu="matMenu" class="energy-map-mat-menu" panelClass="energy-map-mat-menu">
        <ng-template matMenuContent>
          <app-user-profile-menu class="contact-mat-menu"></app-user-profile-menu>
        </ng-template>
      </mat-menu>
    </li>
    <li #contactMenuTrigger="matMenuTrigger" class="link contact-menu" [class.-active]="isContactMenuOpen" [matMenuTriggerFor]="contactMenu">
      <span><app-svg-icon class="phone-icon-image" src="./assets/icons/icon_phone2.svg"></app-svg-icon></span>
      <mat-menu
        #contactMenu="matMenu"
        class="contact-map-mat-menu"
        panelClass="contact-map-mat-menu"
        (menuOpened)="onContactMenuToggle(true)"
        (menuClosed)="onContactMenuToggle(false)"
      >
        <app-contact-info [showFooterText]="true" class="app-contact header-contact-info"></app-contact-info>
      </mat-menu>
    </li>
    <li
      #electricityCostMenuTrigger="matMenuTrigger"
      class="link"
      [class.-active]="isElectricityCostMenuOpen"
      [matMenuTriggerFor]="electricityCostMenu"
      *ngIf="!!authService.permissions.MUNICIPALITY_ELECTRICITY_COST"
    >
      <span class="fa fa-eur fa-2x"></span>
      <mat-menu #electricityCostMenu="matMenu" class="electricity-cost-map-mat-menu" panelClass="electricity-cost-map-mat-menu">
        <ng-template matMenuContent>
          <app-settings-panel class="legend-map-mat-menu"></app-settings-panel>
        </ng-template>
      </mat-menu>
    </li>
    <li
      #cogMenuTrigger="matMenuTrigger"
      class="link legend-button"
      [class.-active]="isCogMenuOpen"
      *ngIf="!!authService.permissions.ENERGY_MAP_LEGEND"
      [matMenuTriggerFor]="cogMenu"
    >
      <span class="fa fa-cog fa-2x legend-button"></span>
      <mat-menu #cogMenu="matMenu" class="legend-map-mat-menu" panelClass="legend-map-mat-menu">
        <ng-template matMenuContent>
          <app-legends-new class="app-legend"></app-legends-new>
        </ng-template>
      </mat-menu>
    </li>
    <li class="link link-menu" (click)="backToMenu()">
      <span class="fa fa-th"></span>
      <span class="link-name">{{ 'module.layout.header.menuText' | translate }}</span>
    </li>
  </ul>
</div>
